import * as Sentry from '@sentry/browser'
import { BrowserTracing } from '@sentry/tracing'

Sentry.init({
  dsn:
    'https://fdf933016f234f76b9d5323051009fc7@o268063.ingest.sentry.io/6525881',
  release: 'my-project-name@2.3.12',
  integrations: [new BrowserTracing()],
  tracesSampleRate: 1.0
})

document.body.addEventListener(
  'error',
  event => {
    if (!event.target) return

    if (event.target.tagName === 'IMG') {
      Sentry.captureMessage(
        `Failed to load image: ${event.target.src}`,
        Sentry?.Severity?.Warning
      )
    } else if (event.target.tagName === 'LINK') {
      Sentry.captureMessage(
        `Failed to load css: ${event.target.href}`,
        Sentry?.Severity?.Warning
      )
    }
  },
  true
)
